<script setup lang="ts">

import '@/assets/styles/footer.css';
</script>

<template>
  <footer class="footer">
    <div class="footer-container">

      <div class="footer-block">
        <h3>Gallus Pflegedienst e.K.</h3>
        <p>
          Gallus Pflegedienst e.K.<br/>
          Inhaber: Mileva Markovic<br/>
          Am Niedwald 53<br/>
          65933 Frankfurt am Main
        </p>
        <p>
          Tel: <a href="tel:+496975009899">069 75009899</a><br/>
          E-Mail:
          <a href="mailto:info@galluspflegedienst.de">
            info@galluspflegedienst.de
          </a><br/>
          Fax: <a href="fax:+496975084926">069 75084926</a>
        </p>
      </div>

      <div class="footer-block">
        <h3>Rechtliches</h3>
        <p>
          Berufsbezeichnung: Pflegefachkraft<br/>
          Verliehen in Deutschland<br/>
          Zuständige Aufsichtsbehörde: Gesundheitsamt Frankfurt am Main
        </p>
      </div>

      <div class="footer-block">
        <h3>Links</h3>
        <ul>
          <li><a href="/impressum">Impressum</a></li>
          <li><a href="/datenschutz">Datenschutz</a></li>
        </ul>
      </div>

    </div>

    <div class="footer-bottom">
      <p>© {{ new Date().getFullYear() }} Gallus Pflegedienst e.K.</p>
      <p class="creator">Webdesign & Entwicklung: Butterweck Digital</p>
    </div>
  </footer>
</template>


<style scoped>

</style>